import { Check } from "lucide-react";

export const LayoutThumb = ({ layout, className = "" }) => (
  <svg viewBox="0 0 1440 810" className={`w-full bg-[var(--cream)] ${className}`} data-testid={`layout-thumb-${layout.id}`}>
    <rect x="81" y="66" width="200" height="16" fill="#252523" opacity="0.6" />
    {layout.slots.map((s) => <rect key={s.key} x={s.x} y={s.y} width={s.w} height={s.h} fill="#C9C2B6" />)}
    <line x1="0" x2="1440" y1="680" y2="680" stroke="#A3A09A" strokeWidth="3" />
    <line x1="0" x2="1440" y1="739" y2="739" stroke="#A3A09A" strokeWidth="3" />
    <rect x="81" y="700" width="120" height="18" fill="#252523" opacity="0.6" />
    <rect x="1159" y="700" width="200" height="18" fill="#252523" opacity="0.6" />
  </svg>
);

export const LayoutPicker = ({ layouts, value, onChange, testid = "layout-option" }) => (
  <div className="grid grid-cols-2 gap-3">
    {layouts.map((l) => {
      const on = l.id === value;
      return (
        <button key={l.id} type="button" onClick={() => onChange(l.id)} data-testid={`${testid}-${l.id}`}
          className={`relative text-left p-2 border-2 transition-colors ${on ? "border-[var(--terracotta)]" : "border-[var(--line)] hover:border-[var(--ink)]/40"}`}>
          <LayoutThumb layout={l} />
          <p className="text-xs font-semibold mt-2">{l.name}</p>
          <p className="text-[11px] text-[var(--muted-ink)]">{l.slots.length} {l.slots.length === 1 ? "image" : "images"}</p>
          {on && <Check size={14} className="absolute top-3 right-3 bg-[var(--terracotta)] text-white p-0.5" />}
        </button>
      );
    })}
  </div>
);
